/* Eyeshells - Collection grid columns persistence (responsive 1–5) 
   Keeps user's choice across pagination / AJAX filter updates.
   Storage: localStorage (fallback: sessionStorage). */

(function () {
  if (window.__esCollectionColsCleanup) {
    try { window.__esCollectionColsCleanup(); } catch (e) {}
  }

  var KEY = 'es_cols_per_row';
  var resizeT = null;
  var domReadyHandler = null;
  var clickHandler = null;
  var keydownHandler = null;
  var collectionUpdatedHandler = null;
  var resizeHandler = null;
  var pagehideHandler = null;
  var pageshowHandler = null;
  var clickBound = false;
  var keydownBound = false;
  var collectionUpdatedBound = false;
  var resizeBound = false;
  var pagehideBound = false;
  var pageshowBound = false;
  var active = false;
  var switchGuardT = null;
  var switchGeometryClearT = null;
  var switchPrepareToken = 0;
  var switchPrepareT = null;

  function getStore() {
    try {
      var ls = window.localStorage;
      var x = '__es_test__';
      ls.setItem(x, '1');
      ls.removeItem(x);
      return ls;
    } catch (e) {
      try { return window.sessionStorage; } catch (e2) { return null; }
    }
  }

  function clampCols(v) {
    v = parseInt(v, 10);
    if (v >= 1 && v <= 5) return v;
    return null;
  }

  function isTabletPortraitViewport() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (!w || w < 768 || w >= 1200) return false;
    try {
      if (window.matchMedia && window.matchMedia('(orientation: portrait)').matches) return true;
    } catch (e) {}
    return w < 900;
  }

  function getDefaultColsForViewport() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w && w < 768) return 2;
    if (w && w < 1200) return isTabletPortraitViewport() ? 3 : 4;
    return 4;
  }

  function normalizeCols(cols) {
    cols = clampCols(cols);
    if (!cols) return null;

    var w = window.innerWidth || document.documentElement.clientWidth || 0;

    if (w && w < 768) {
      return (cols === 1 || cols === 2) ? cols : 2;
    }

    if (w && w < 1200) {
      if (cols < 2) return 2;
      if (isTabletPortraitViewport() && cols > 3) return 3;
      if (cols > 4) return 4;
      return cols;
    }

    if (cols < 3) return 4;
    if (cols > 5) return 5;
    return cols;
  }


  function hasControls() {
    try {
      return !!document.querySelector('.prod_per [data-es-grid-cols]');
    } catch (e) {
      return false;
    }
  }

  function hasTargetGrid() {
    try {
      return !!document.querySelector('.template-collection .product-grid-view .js_size_prod, .template-search .product-grid-view .js_size_prod');
    } catch (e) {
      return false;
    }
  }

  function setHtmlColsClass(cols) {
    try {
      var el = document.documentElement;
      el.classList.remove('es-cols-1', 'es-cols-2', 'es-cols-3', 'es-cols-4', 'es-cols-5');
      if (cols) el.classList.add('es-cols-' + cols);
    } catch (e) {}
  }


  function syncUiState(cols) {
    try {
      var buttons = document.querySelectorAll('.prod_per [data-es-grid-cols]');
      buttons.forEach(function (btn) {
        var isActive = parseInt(btn.getAttribute('data-es-grid-cols'), 10) === cols;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      var wraps = document.querySelectorAll('.collection_prod');
      wraps.forEach(function (wrap) {
        wrap.classList.remove('size_1', 'size_2', 'size_3', 'size_4', 'size_5');
        wrap.classList.add('size_' + cols);
      });

    } catch (e) {}
  }

  function detectCurrentUiCols() {
    try {
      var active = document.querySelector('.prod_per [data-es-grid-cols].active, .prod_per [data-es-grid-cols][aria-checked="true"]');
      if (active) return clampCols(active.getAttribute('data-es-grid-cols'));
    } catch (e) {}
    return null;
  }


  function detectCurrentWrapperCols() {
    try {
      var wrap = document.querySelector('.collection_prod');
      if (!wrap) return null;
      for (var cols = 1; cols <= 5; cols += 1) {
        if (wrap.classList.contains('size_' + cols)) return cols;
      }
    } catch (e) {}
    return null;
  }

  function detectCurrentGridCols() {
    try {
      var item = document.querySelector('.template-collection .product-grid-view .js_size_prod, .template-search .product-grid-view .js_size_prod');
      if (!item) return null;
      var cls = item.classList;
      if (cls.contains('col-12')) return 1;
      if (cls.contains('col-6')) return 2;
      if (cls.contains('col-md-4') || cls.contains('col-lg-4')) return 3;
      if (cls.contains('col-md-3') || cls.contains('col-lg-3')) return 4;
      if (cls.contains('col-lg-2dot4')) return 5;
    } catch (e) {}
    return null;
  }


  function clearSwitchGeometry() {
    try {
      var root = document.documentElement;
      if (!root) return;
      root.classList.remove('es-collection-cols-geometry-locked');
      root.style.removeProperty('--es-collection-switch-media-height');
    } catch (e) {}
  }

  function getTargetDesktopGeometry(cols) {
    try {
      var viewport = window.innerWidth || document.documentElement.clientWidth || 0;
      if (viewport < 1200 || cols < 3 || cols > 5) return null;

      var row = document.querySelector('.template-collection .product-grid-view .es-collection-grid-row, .template-search .product-grid-view .es-collection-grid-row, .template-collection .product-grid-view .row.grid-uniform, .template-search .product-grid-view .row.grid-uniform');
      var sample = document.querySelector('.template-collection .product-grid-view .js_size_prod, .template-search .product-grid-view .js_size_prod');
      if (!row || !sample || !row.getBoundingClientRect || !window.getComputedStyle) return null;

      var rowRect = row.getBoundingClientRect();
      var rowWidth = rowRect && rowRect.width ? rowRect.width : 0;
      if (!rowWidth) return null;

      var itemStyle = window.getComputedStyle(sample);
      var padLeft = parseFloat(itemStyle.paddingLeft) || 0;
      var padRight = parseFloat(itemStyle.paddingRight) || 0;
      var mediaWidth = Math.max(1, (rowWidth / cols) - padLeft - padRight);
      var mediaHeight = mediaWidth * 25 / 29;
      var imageSize = Math.max(168, Math.round(mediaWidth * getBoostForViewport(cols, viewport)));

      return { mediaHeight: mediaHeight, imageSize: imageSize };
    } catch (e) {
      return null;
    }
  }

  function primeTargetDesktopImageSizes(cols) {
    var geometry = getTargetDesktopGeometry(cols);
    if (!geometry) return null;

    try {
      var imgs = document.querySelectorAll('.template-collection .product-grid-view .es-card-media-desktop img[data-es-grid-image], .template-search .product-grid-view .es-card-media-desktop img[data-es-grid-image]');
      imgs.forEach(function (img) {
        var next = geometry.imageSize + 'px';
        if (img.getAttribute('sizes') !== next) img.setAttribute('sizes', next);
      });
    } catch (e) {}

    return geometry;
  }

  function primeTargetDesktopGeometry(cols) {
    var geometry = primeTargetDesktopImageSizes(cols);
    if (!geometry) {
      clearSwitchGeometry();
      return null;
    }

    try {
      var root = document.documentElement;
      root.style.setProperty('--es-collection-switch-media-height', geometry.mediaHeight.toFixed(3) + 'px');
      root.classList.add('es-collection-cols-geometry-locked');
    } catch (e) {}

    return geometry;
  }

  function setSwitchingState(isOn) {
    try {
      var root = document.documentElement;
      if (!root) return;
      if (switchGuardT) {
        clearTimeout(switchGuardT);
        switchGuardT = null;
      }
      if (switchGeometryClearT) {
        clearTimeout(switchGeometryClearT);
        switchGeometryClearT = null;
      }
      if (isOn) {
        root.classList.add('es-collection-cols-switching');
        switchGuardT = setTimeout(function () {
          try { root.classList.remove('es-collection-cols-switching'); } catch (e) {}
          switchGuardT = null;
          switchGeometryClearT = setTimeout(function () {
            clearSwitchGeometry();
            switchGeometryClearT = null;
          }, 34);
        }, 420);
      } else {
        root.classList.remove('es-collection-cols-switching');
        clearSwitchGeometry();
      }
    } catch (e) {}
  }

  function cancelPreparedSwitch() {
    switchPrepareToken += 1;
    if (switchPrepareT) {
      clearTimeout(switchPrepareT);
      switchPrepareT = null;
    }
  }

  function predecodeExpandedDesktopImages(cols, done) {
    var viewport = window.innerWidth || document.documentElement.clientWidth || 0;
    if (viewport < 1200 || cols !== 3 || typeof Promise === 'undefined') {
      done();
      return;
    }

    var token = ++switchPrepareToken;
    var images = [];
    try {
      var candidates = document.querySelectorAll('.template-collection .product-grid-view .es-card-media-desktop img[data-es-grid-image], .template-search .product-grid-view .es-card-media-desktop img[data-es-grid-image]');
      candidates.forEach(function (img) {
        if (!img || typeof img.decode !== 'function') return;
        var rect = img.getBoundingClientRect ? img.getBoundingClientRect() : null;
        if (!rect || rect.bottom < -120 || rect.top > (window.innerHeight || 900) + 720) return;
        images.push(img);
      });
    } catch (e) {}

    if (!images.length) {
      done();
      return;
    }

    var finished = false;
    function finish() {
      if (finished || token !== switchPrepareToken) return;
      finished = true;
      if (switchPrepareT) {
        clearTimeout(switchPrepareT);
        switchPrepareT = null;
      }
      done();
    }

    /* Setting the target `sizes` value before layout asks Chromium for the wider
       3-column source candidate. Wait briefly for visible candidates to decode,
       so the atomic grid-width change does not expose a late bitmap swap. */
    var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    raf(function () {
      raf(function () {
        if (token !== switchPrepareToken) return;
        var jobs = images.map(function (img) {
          try { return img.decode().catch(function () {}); }
          catch (e) { return Promise.resolve(); }
        });
        Promise.all(jobs).then(finish, finish);
      });
    });

    switchPrepareT = setTimeout(finish, 220);
  }

  function directApplyGridItemClasses(cols) {
    try {
      var items = document.querySelectorAll('.template-collection .product-grid-view .js_size_prod, .template-search .product-grid-view .js_size_prod');
      if (!items || !items.length) return;

      items.forEach(function (it) {
        it.classList.remove(
          'col-lg-1','col-lg-2','col-lg-3','col-lg-4','col-lg-5','col-lg-6','col-lg-7','col-lg-8','col-lg-9','col-lg-10','col-lg-11','col-lg-12','col-lg-2dot4',
          'col-md-1','col-md-2','col-md-3','col-md-4','col-md-5','col-md-6','col-md-7','col-md-8','col-md-9','col-md-10','col-md-11','col-md-12',
          'col-12','col-6'
        );
        if (cols === 1) it.classList.add('col-12');
        if (cols === 2) it.classList.add('col-6');
        if (cols === 3) it.classList.add('col-md-4');
        if (cols === 4) it.classList.add('col-md-3');
        if (cols === 5) it.classList.add('col-lg-2dot4');
      });
    } catch (e) {}
  }

  function scheduleImageSizeSync(cols, opts) {
    opts = opts || {};

    var run = function () {
      if (window.__esCollectionImageSizeRAF) {
        try { window.cancelAnimationFrame(window.__esCollectionImageSizeRAF); } catch (e) {}
      }

      /* Column switches prime the target desktop `sizes` value before the grid width
         changes. Confirm it once after layout settles instead of rewriting it across
         several delayed passes, which can make Chromium select and repaint multiple
         responsive-image candidates during one visible switch. */
      window.__esCollectionImageSizeRAF = window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          syncImageSizes(cols);
        });
      });
    };

    if (opts.deferUntilLoad && document.readyState !== 'complete') {
      var once = function () {
        try { window.removeEventListener('load', once); } catch (e) {}
        run();
      };
      window.addEventListener('load', once, { once: true });
      return;
    }

    if (opts.delay && opts.delay > 0) {
      window.setTimeout(run, opts.delay);
      return;
    }

    run();
  }

  function isElementHidden(el) {
    try {
      if (!el || !window.getComputedStyle) return false;
      var node = el;
      while (node && node !== document.documentElement) {
        var style = window.getComputedStyle(node);
        if (!style) break;
        if (style.display === 'none' || style.visibility === 'hidden') return true;
        node = node.parentElement;
      }
    } catch (e) {}
    return false;
  }

  function getFallbackCardWidth(cols, viewport) {
    if (viewport < 768) {
      return cols === 1 ? Math.max(300, viewport - 24) : Math.max(168, (viewport - 24) / 2);
    }
    if (viewport < 1200) {
      return Math.max(184, (viewport - 40) / Math.max(2, cols));
    }
    return Math.max(210, (viewport - 56) / Math.max(3, cols));
  }

  function getBoostForViewport(cols, viewport) {
    if (viewport < 768 && cols === 1) return 1.12;
    if (viewport < 768) return 1.08;
    if (viewport < 1200 && cols === 2) return 1.09;
    if (viewport < 1200) return 1.07;
    if (viewport >= 1200 && cols === 3) return 1.10;
    if (viewport >= 1200 && cols === 4) return 1.07;
    if (viewport >= 1200 && cols === 5) return 1.04;
    return 1.06;
  }

  function syncImageSizes(cols) {
    try {
      cols = normalizeCols(cols) || read() || 4;
      var viewport = window.innerWidth || document.documentElement.clientWidth || 0;
      var imgs = document.querySelectorAll('.template-collection img[data-es-grid-image], .template-search img[data-es-grid-image]');
      if (!imgs.length) return;

      imgs.forEach(function (img) {
        var media = img.closest('.es-card-media-desktop, .es-card-media-mobile');
        var isHidden = isElementHidden(media || img);
        var box = img.closest('.es-swipe-link, .engoj_find_img, .js_size_prod, .es-card-media-desktop, .es-card-media-mobile, .img-product') || img.parentElement || img;
        var rect = box && box.getBoundingClientRect ? box.getBoundingClientRect() : null;
        var width = rect && rect.width ? rect.width : 0;

        if (isHidden) {
          if (img.getAttribute('sizes') !== '1px') {
            img.setAttribute('sizes', '1px');
          }
          return;
        }

        if (!width) {
          var gridItem = img.closest('.js_size_prod');
          var gridRect = gridItem && gridItem.getBoundingClientRect ? gridItem.getBoundingClientRect() : null;
          width = gridRect && gridRect.width ? gridRect.width : 0;
        }

        if (!width) {
          width = getFallbackCardWidth(cols, viewport);
        }

        var boost = getBoostForViewport(cols, viewport);
        var sizePx = Math.max(168, Math.round(width * boost));
        var sizeValue = String(sizePx) + 'px';
        if (img.getAttribute('sizes') !== sizeValue) {
          img.setAttribute('sizes', sizeValue);
        }
      });
    } catch (e) {}
  }


  function apply(cols, opts) {
    cols = normalizeCols(cols);
    if (!cols) return;

    var html = document.documentElement;
    var currentHtmlMatch = (html && html.className ? html.className : '').match(/\bes-cols-(1|2|3|4|5)\b/);
    var currentHtmlCols = currentHtmlMatch ? parseInt(currentHtmlMatch[1], 10) : null;
    var currentGridCols = detectCurrentGridCols();
    var currentUiCols = detectCurrentUiCols();
    var currentWrapperCols = detectCurrentWrapperCols();
    var alreadyApplied = currentHtmlCols === cols && currentGridCols === cols && currentUiCols === cols && currentWrapperCols === cols;
    var forceImageSync = !!(opts && opts.forceImageSync);

    if (!(opts && opts.silent) && !alreadyApplied) {
      primeTargetDesktopGeometry(cols);
      setSwitchingState(true);
    }

    if (currentHtmlCols !== cols) setHtmlColsClass(cols);
    if (currentUiCols !== cols || currentWrapperCols !== cols) syncUiState(cols);
    if (currentGridCols !== cols) directApplyGridItemClasses(cols);

    if (!alreadyApplied || forceImageSync) {
      scheduleImageSizeSync(cols, {
        aggressive: !(opts && opts.silent),
        deferUntilLoad: !!(opts && opts.silent)
      });
    }

    if (opts && opts.silent) return;
  }

  function read() {

    var store = getStore();
    if (!store) return null;
    return clampCols(store.getItem(KEY));
  }

  function write(cols) {
    var store = getStore();
    if (!store) return;
    store.setItem(KEY, String(cols));
  }

  // Public hook so AJAX filtering can re-apply after replacing the grid
  window.ES_applyCollectionCols = function () {
    if (!(hasControls() || hasTargetGrid())) return;
    var cols = read() || detectCurrentUiCols() || detectCurrentGridCols() || getDefaultColsForViewport();
    apply(cols, { silent: true, forceImageSync: true });
  };

  function bindRuntime() {
    if (clickHandler && !clickBound) {
      document.addEventListener('click', clickHandler);
      clickBound = true;
    }
    if (keydownHandler && !keydownBound) {
      document.addEventListener('keydown', keydownHandler);
      keydownBound = true;
    }
    if (collectionUpdatedHandler && !collectionUpdatedBound) {
      document.addEventListener('es:collection:updated', collectionUpdatedHandler);
      collectionUpdatedBound = true;
    }
    if (resizeHandler && !resizeBound) {
      window.addEventListener('resize', resizeHandler, { passive: true });
      resizeBound = true;
    }
    if (pagehideHandler && !pagehideBound) {
      window.addEventListener('pagehide', pagehideHandler);
      pagehideBound = true;
    }
    if (pageshowHandler && !pageshowBound) {
      window.addEventListener('pageshow', pageshowHandler);
      pageshowBound = true;
    }
  }

  function unbindRuntime() {
    if (clickHandler && clickBound) {
      document.removeEventListener('click', clickHandler);
      clickBound = false;
    }
    if (keydownHandler && keydownBound) {
      document.removeEventListener('keydown', keydownHandler);
      keydownBound = false;
    }
    if (collectionUpdatedHandler && collectionUpdatedBound) {
      document.removeEventListener('es:collection:updated', collectionUpdatedHandler);
      collectionUpdatedBound = false;
    }
    if (resizeHandler && resizeBound) {
      try { window.removeEventListener('resize', resizeHandler, { passive: true }); } catch (e) {
        try { window.removeEventListener('resize', resizeHandler); } catch (e2) {}
      }
      resizeBound = false;
    }
    if (pagehideHandler && pagehideBound) {
      try { window.removeEventListener('pagehide', pagehideHandler); } catch (e) {}
      pagehideBound = false;
    }
    if (pageshowHandler && pageshowBound) {
      try { window.removeEventListener('pageshow', pageshowHandler); } catch (e) {}
      pageshowBound = false;
    }
  }

  function onDomReady() {
    active = true;
    bindRuntime();
    if (!(hasControls() || hasTargetGrid())) return;
    var cols = read() || detectCurrentUiCols() || detectCurrentGridCols() || getDefaultColsForViewport();
    apply(cols, { silent: true });
  }

  function selectControl(control, options) {
    options = options || {};
    if (!control) return;
    var cols = clampCols(control.getAttribute('data-es-grid-cols'));
    cols = normalizeCols(cols) || cols;
    if (!cols) return;

    var previousCols = detectCurrentGridCols() || detectCurrentUiCols() || read();
    write(cols);

    function restoreControlFocus() {
      if (!options.focus) return;
      var activeControl = control.closest('.prod_per') && control.closest('.prod_per').querySelector('[data-es-grid-cols="' + cols + '"]');
      if (activeControl) {
        try { activeControl.focus({ preventScroll: true }); }
        catch (error) { try { activeControl.focus(); } catch (fallbackError) {} }
      }
    }

    if (previousCols === cols) {
      cancelPreparedSwitch();
      setHtmlColsClass(cols);
      syncUiState(cols);
      scheduleImageSizeSync(cols, { delay: 60 });
      restoreControlFocus();
      return;
    }

    cancelPreparedSwitch();

    function commit() {
      /* Apply the target height lock in the same task as the class swap. During
         predecode the old grid stays geometrically untouched, so preparation
         itself cannot create a visible vertical jump. */
      primeTargetDesktopGeometry(cols);
      setSwitchingState(true);
      setHtmlColsClass(cols);
      syncUiState(cols);
      directApplyGridItemClasses(cols);
      scheduleImageSizeSync(cols, { delay: 0 });
      restoreControlFocus();
    }

    var viewport = window.innerWidth || document.documentElement.clientWidth || 0;
    var expandsToThree = viewport >= 1200 && cols === 3 && previousCols && previousCols > 3;
    if (expandsToThree) {
      /* Request the wider responsive-image candidate without changing card
         height or grid classes. Commit only after visible images are decoded
         (or the short safety timeout expires). */
      primeTargetDesktopImageSizes(cols);
      syncUiState(cols);
      predecodeExpandedDesktopImages(cols, commit);
    } else {
      commit();
    }
  }

  function visibleControls(group) {
    if (!group) return [];
    return Array.prototype.slice.call(group.querySelectorAll('[data-es-grid-cols]')).filter(function (control) {
      if (control.disabled || control.getAttribute('aria-hidden') === 'true') return false;
      if (!window.getComputedStyle) return true;
      var style = window.getComputedStyle(control);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  // Persist when the customer changes grid density.
  clickHandler = function (e) {
    if (!active || !e.target || !e.target.closest) return;
    var control = e.target.closest('.prod_per [data-es-grid-cols]');
    if (!control) return;
    e.preventDefault();
    selectControl(control);
  };

  keydownHandler = function (e) {
    if (!active || !e.target || !e.target.closest) return;
    var control = e.target.closest('.prod_per [data-es-grid-cols]');
    if (!control) return;
    var key = e.key;
    if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'ArrowUp' && key !== 'ArrowDown' && key !== 'Home' && key !== 'End') return;

    var group = control.closest('[role="radiogroup"]') || control.closest('.prod_per');
    var controls = visibleControls(group);
    if (!controls.length) return;
    var current = controls.indexOf(control);
    if (current < 0) current = 0;
    var next = current;
    if (key === 'Home') next = 0;
    else if (key === 'End') next = controls.length - 1;
    else if (key === 'ArrowLeft' || key === 'ArrowUp') next = (current - 1 + controls.length) % controls.length;
    else next = (current + 1) % controls.length;

    e.preventDefault();
    selectControl(controls[next], { focus: true });
  };

  collectionUpdatedHandler = function () {
    if (!active) return;
    window.ES_applyCollectionCols();
  };

  // If theme's resize logic overwrites the user's choice, re-apply shortly after resize settles
  resizeHandler = function () {
    if (!active || document.visibilityState === 'hidden') return;
    if (resizeT) clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      resizeT = null;
      if (!(hasControls() || hasTargetGrid())) return;
      apply(read() || detectCurrentUiCols() || detectCurrentGridCols() || getDefaultColsForViewport(), { silent: true });
    }, 150);
  };

  pagehideHandler = function () {
    cancelPreparedSwitch();
    if (resizeT) {
      clearTimeout(resizeT);
      resizeT = null;
    }
    if (switchGuardT) {
      clearTimeout(switchGuardT);
      switchGuardT = null;
    }
    if (switchGeometryClearT) {
      clearTimeout(switchGeometryClearT);
      switchGeometryClearT = null;
    }
    clearSwitchGeometry();
    try { document.documentElement.classList.remove('es-collection-cols-switching'); } catch (e) {}
  };

  pageshowHandler = function () {
    active = true;
    if (!(hasControls() || hasTargetGrid())) return;
    var cols = read() || detectCurrentUiCols() || detectCurrentGridCols() || getDefaultColsForViewport();
    apply(cols, { silent: true });
  };

  // Apply on first paint (after theme init)
  domReadyHandler = onDomReady;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domReadyHandler);
  } else {
    onDomReady();
  }

  window.__esCollectionColsCleanup = function () {
    active = false;
    cancelPreparedSwitch();
    if (resizeT) {
      clearTimeout(resizeT);
      resizeT = null;
    }
    if (switchGuardT) {
      clearTimeout(switchGuardT);
      switchGuardT = null;
    }
    if (switchGeometryClearT) {
      clearTimeout(switchGeometryClearT);
      switchGeometryClearT = null;
    }
    clearSwitchGeometry();
    try { document.documentElement.classList.remove('es-collection-cols-switching'); } catch (e) {}
    if (domReadyHandler) document.removeEventListener('DOMContentLoaded', domReadyHandler);
    unbindRuntime();
  };

})();
